<template lang="pug">
.input-multi-choice(:data-vertical='isVertical', :data-show-checkbox='labelNotDisplayable')
  .input-multi-choice__group(v-for='(item, index) in items', :data-selected='dataSelected(item.value)')
    input.input-multi-choice__group__input(
      type='checkbox',
      :id='getInputId(index)',
      :value='item.value',
      v-model='selectedValue'
    )
    label-base.input-multi-choice__group__label(:for='getInputId(index)')
      .input-multi-choice__group__label__check {{ item.label }}
      image-base.input-multi-choice__group__label__image(v-if='item.choiceImage', :src='item.choiceImage')
      .input-multi-choice__group__label__text(v-else) {{ item.choiceText }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import LabelBase from '@/components/atoms/LabelBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'
import { InputItem } from '@/models/inputItem'

/**
 * 複数選択
 */
@Component({
  components: {
    LabelBase,
    ImageBase,
  },
})
export default class InputMultiChoice extends Vue {
  // 選択肢情報
  @Prop()
  items!: InputItem[]

  // 選択値
  @Prop()
  value!: string[]

  // 縦書きフラグ
  @Prop({ default: false })
  isVertical?: boolean

  // ラベル非表示フラグ
  @Prop({ default: false })
  labelNotDisplayable?: boolean

  // コンポーネント単位のユニークID取得
  private readonly UID = this.$uuid.v4()

  // inputタグの個別ID
  private getInputId(index: number): string {
    return `id${this.UID}_${index}`
  }

  // 選択状態に応じてカスタムデータ属性を付与
  private dataSelected(value: string): boolean {
    return this.value.includes(value)
  }

  // 選択値のゲッターセッター
  get selectedValue(): string[] {
    return this.value
  }
  set selectedValue(value: string[]) {
    this.$emit('input', value)
  }
}
</script>

<style lang="stylus" scoped>
.input-multi-choice
  &__group
    display flex
    padding 5px 10px 5px 0px
    &__input
      display none
      margin 0 5px 0 0
    &__label
      display flex
      cursor pointer
      &__check
        display flex
        align-items center
        justify-content center
        min-width 80px
        margin 0 10px 0 0
        background-color var(--color-study-input-choice__background)
        border 1px solid var(--color-study-input-choice__border)
      &__image
        max-width calc(100% - 90px)
        max-height 250px
      &__text
        display flex
        align-items center
    &[data-selected='true'] &__label
      &__check
        background-color var(--color-study-input-choice-selected__background)
        border 2px solid var(--color-study-input-choice-selected__border)
      &__image
        border 2px solid var(--color-study-input-choice-selected__border)
      &__text
        color var(--color-study-input-choice-selected__border)
  &[data-vertical='true'] &__group
    padding 0px 5px 10px 5px
    &__input
      margin 0 0 5px 0
    &__label
      &__check
        margin 0 0 10px 0
        min-width unset
        min-height 80px
      &__image
        max-width 250px
        max-height 100%
        height 100%
  &[data-show-checkbox='true'] &__group
    &__input
      display inline
    &__label
      &__check
        display none
</style>
